import React from "react";

// Lazy loading components for improved performance
// React.lazy is used to dynamically import components when they are needed
export const UserManagement = React.lazy(() => import("./UserList/index.page"));
export const UserDetails = React.lazy(() => import("./UserDetails/index.page"));
export const UserNutrientDetails = React.lazy(() =>
  import("./UserNutritionDetails/index.page")
);
